import React, { FC } from "react"
import { Grid, Button } from "@mui/material"
import { GridColDef } from "@mui/x-data-grid-premium"
import { useProductListRequest } from "src/hooks/api"
import { useQueryParamsState } from "src/hooks/ui"
import { ProductColumnsDataGrid } from "src/components/columns/product"
import { ManufacturerProjectFilters } from "src/components/forms"
import { ProductList } from "src/components/sections/product/productList"
import { DataLoad, InnerLink } from "../../ui"

const columns: GridColDef[] = [
  ProductColumnsDataGrid.Name,
  ProductColumnsDataGrid.ProductTypeName,
  ProductColumnsDataGrid.ShelfLife,
  ProductColumnsDataGrid.Tips,
  ProductColumnsDataGrid.Ranges,
  ProductColumnsDataGrid.IsProductInUse,
]

interface ProductsOfManufacturerProps {
  manufacturerId: number;
}

export const ProductsOfManufacturer: FC<ProductsOfManufacturerProps> = ({
  manufacturerId,
}) => {
  const params = useQueryParamsState()
  const { isInitialLoading, isError, data, error } = useProductListRequest({
    params: {
      ...params,
      manufacturerId,
    },
  })

  return (
    <Grid container direction="column" spacing={2} wrap="nowrap">
      <Grid item>
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <InnerLink to={`/db-management?manufacturerId=${manufacturerId}`}>
              <Button variant="contained">Add product</Button>
            </InnerLink>
          </Grid>
          <Grid item>
            <ManufacturerProjectFilters />
          </Grid>
        </Grid>
      </Grid>
      <Grid item minWidth={0}>
        <DataLoad
          isLoading={false}
          isError={isError}
          errorMessage={error?.message}
        >
          <ProductList
            loading={isInitialLoading}
            count={data?.count || 0}
            data={data?.rows || []}
            columns={columns}
          />
        </DataLoad>
      </Grid>
    </Grid>
  )
}
